// extracted by mini-css-extract-plugin
export default {"container":"FullContact_container__WVBAN"};